import { get, set } from '@/helper/localStorage'
import _get from 'lodash/get'
import fields from '@/field/table/category'

export default {
  namespaced: true,
  state: {
    tableFields: get('categoryV2TableFields', fields),
    tableData: [],
    tablePagination: get('categoryV2TablePagination'),
    tableKeyword: get('categoryV2TableKeyword'),
    tableSort: get('categoryV2TableSort'),
    tableFilter: get('categoryV2TableFilter', []),
    detailData: get('categoryV2DetailData'),
    loadingTable: false,
    loadingDetail: false,
    loadingSubmit: false,
  },
  getters: {
    tableFields: state => {
      if (!state.tableFields) return undefined
      const visibilities = state.tableFields.reduce((obj, item) => Object.assign(obj, { [item.key]: item.visibility }), {})
      return fields.map(item => ({
        ...item,
        visibility: item.key in visibilities ? visibilities[item.key] : item.visibility,
      }))
    },
    tableSort: state => {
      if (!state.tableSort) return undefined
      const symbol = state.tableSort.direction === 'desc' ? '-' : ''
      return `${symbol}${state.tableSort.key}`
    },
    tableData: state => {
      if (!state.tableData) return []
      return state.tableData.map(item => ({ ...item }))
    },
    detailData: state => {
      if (!state.detailData) return undefined
      return { ...state.detailData }
    },
    tableFilter: state => {
      if (!state.tableFilter) return []
      return state.tableFilter
        .reduce((acc, elem) => Object.assign(acc, {
          [`filter[${elem.key}]`]: Array.isArray(elem.value)
            ? elem.value.join(',')
            : elem.value,
        }), {})
    },
    tableParams: (state, getters, rootState) => ({
      'filter[keyword]': state.tableKeyword,
      ...getters.tableFilter,
      sort: getters.tableSort,
      page: _get(state, 'tablePagination.current_page', 1),
      limit: rootState.appConfig.settings.tablePerPage,
    }),
  },
  mutations: {
    SET_TABLE_FIELDS(state, val) {
      set('categoryV2TableFields', val)
      state.tableFields = val
    },
    RESET_TABLE_FIELDS(state) {
      set('categoryV2TableFields', fields)
      state.tableFields = fields
    },
    SET_TABLE_DATA(state, val) {
      state.tableData = val
    },
    SET_TABLE_PAGINATION(state, val) {
      set('categoryV2TablePagination', val)
      state.tablePagination = val
    },
    SET_TABLE_KEYWORD(state, val) {
      set('categoryV2TableKeyword', val)
      state.tableKeyword = val
    },
    SET_DETAIL_DATA(state, val) {
      set('categoryV2DetailData', val)
      state.detailData = val
    },
    SET_TABLE_SORT(state, val) {
      set('categoryV2TableSort', val)
      state.tableSort = val
    },
    SET_TABLE_FILTER(state, val) {
      set('categoryV2TableFilter', val)
      state.tableFilter = val
    },
    SET_LOADING_TABLE(state, val) {
      state.loadingTable = val
    },
    SET_LOADING_DETAIL(state, val) {
      state.loadingDetail = val
    },
    SET_LOADING_SUBMIT(state, val) {
      state.loadingSubmit = val
    },
  },
  actions: {
    getTableData({ commit, getters }) {
      commit('SET_LOADING_TABLE', true)
      const { tableParams: params } = getters
      return this._vm.$http.get('/v2/admin/categories', { params })
        .then(({ data }) => {
          commit('SET_TABLE_DATA', data.data || [])
          commit('SET_TABLE_PAGINATION', data.meta || {})
        })
        .finally(() => {
          commit('SET_LOADING_TABLE', false)
        })
    },
    getDetail({ commit }, id) {
      commit('SET_LOADING_DETAIL', true)
      return this._vm.$http.get(`/v2/admin/categories/${id}`)
        .then(({ data }) => {
          commit('SET_DETAIL_DATA', data.data)
        })
        .finally(() => {
          commit('SET_LOADING_DETAIL', false)
        })
    },
    delete(_, id) {
      return this._vm.$http.delete(`/v2/admin/categories/${id}`)
    },
    create({ commit }, data) {
      commit('SET_LOADING_SUBMIT', true)

      return this._vm.$http.post('/v2/admin/categories', data)
        .finally(() => {
          commit('SET_LOADING_SUBMIT', false)
        })
    },
    update({ commit }, { id, data }) {
      commit('SET_LOADING_SUBMIT', true)

      return this._vm.$http.patch(`/v2/admin/categories/${id}`, data)
        .then(res => {
          commit('SET_DETAIL_DATA', res.data?.data)
        })
        .finally(() => {
          commit('SET_LOADING_SUBMIT', false)
        })
    },
    searchParents(_, payload) {
      return this._vm.$http.get('/v2/admin/categories', {
        params: {
          'filter[is_root]': true,
          'filter[keyword]': payload ? payload.keyword : undefined,
          'filter[ids]': payload ? payload.ids : undefined,
          limit: payload ? payload.perPage : undefined,
        },
      })
        .then(({ data }) => data.data)
        .catch(() => [])
    },
  },
}
